import styled, { css } from 'styled-components';

import { mediaMixin, spaceMixin, Tabs, token } from '@zillow/constellation';

export const StyledTabContainer = styled.div`
  margin-top: -${spaceMixin('sm')};
  ${mediaMixin(
    'md',
    css`
      min-height: 600px;
    `,
  )};
`;

export const StyledTabsList = styled(Tabs.List)`
  z-index: ${token('zIndices.modal')};
  position: sticky;
  top: -${spaceMixin('sm')};
  background-color: ${token('colors.white')};

  > button {
    ${mediaMixin(
      'sm_lte',
      css`
        font-size: ${token('fontSizes.bodySmall')}px;
      `,
    )};

    /**
            Instead of using xs_lte breakpoint here, using
            a maximum width that's slightly larger to fit
            tab heading text in screen sizes slightly larger than xs
        */
    @media (max-width: 365px) {
      font-size: ${token('fontSizes.finePrint')}px;
    }
  }
`;
